class Brand {
    brandId: number;
    brandName: string;

    constructor() {
        this.brandId = 0;
        this.brandName = "";
    }
}

export default Brand;